export default __webpack_public_path__ + "static/media/257.dbd25a2f.jpg";